import { render, staticRenderFns } from "./main-edit.vue?vue&type=template&id=18e11160&scoped=true&"
import script from "./main-edit.vue?vue&type=script&lang=js&"
export * from "./main-edit.vue?vue&type=script&lang=js&"
import style0 from "./main-edit.vue?vue&type=style&index=0&id=18e11160&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e11160",
  null
  
)

export default component.exports